export default __webpack_public_path__ + "static/media/rosario.b2e191b6.jpg";